import React, {
  useState,
  useEffect,
} from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Hero from "../components/Hero";
import WhyChoose from "../components/WhyChoose";
import LifeAtSchool from "../components/LifeAtSchool";
import News from "../components/News";
import Footer from "../components/Footer";
import HomeAbout from "../components/HomeAbout";
import HomeVirtualTour from "../components/HomeVirtualTour";
import topperImg from "../assets/Toppers image.jpg";

import {
  FaTimes,
  FaArrowRight,
} from "react-icons/fa";

const Home = () => {
  const [open, setOpen] =
    useState(false);

  const [popup, setPopup] =
    useState(false);

  const [notices, setNotices] =
    useState([]);

  useEffect(() => {
    fetch(
      "https://stjosephweb.ilakshyaerp.in/api/notices"
    )
      .then((res) =>
        res.json()
      )
      .then((data) =>
        setNotices(data)
      );

    const alreadyShown =
      sessionStorage.getItem(
        "homePopupShown"
      );

    if (!alreadyShown) {
      setPopup(true);

      sessionStorage.setItem(
        "homePopupShown",
        "yes"
      );
    }
  }, []);

  return (
    <>
      {/* WELCOME POPUP */}
      {popup && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[99999] flex items-center justify-center px-5">

          <div className="relative w-full max-w-6xl bg-white rounded-[25px] overflow-hidden shadow-[0_25px_80px_rgba(0,0,0,0.35)]">

            {/* TOP DESIGN */}
            <div className="h-3 bg-gradient-to-r from-[#072F5F] via-[#0B4F9C] to-[#D4A017]"></div>

            {/* CLOSE BUTTON */}
            <button
              onClick={() =>
                setPopup(false)
              }
              className="absolute top-5 right-5 w-11 h-11 rounded-full bg-gray-100 hover:bg-red-500 hover:text-white flex items-center justify-center text-[#072F5F] transition-all duration-300"
            >

              <FaTimes />

            </button>

            {/* CONTENT */}
            <div className="p-3 md:p-5">

              <img
                src={topperImg}
                alt="School Toppers"
                className="
      w-full
      h-auto
      rounded-2xl
      object-contain
    "
              />


            </div>

          </div>

        </div>
      )}

      {/* HEADER */}
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      {/* ANNOUNCEMENT */}
      <div className="w-full bg-[#072F5F] overflow-hidden border-y border-[#0B4F9C]">

        <div className="max-w-[1600px] mx-auto flex items-center">

          {/* LABEL */}
          <div className="bg-[#D4A017] text-white font-bold px-5 md:px-8 py-4 whitespace-nowrap text-sm md:text-base tracking-wide shadow-lg">

            📢 ANNOUNCEMENT

          </div>

          {/* MARQUEE */}
          <div className="relative flex-1 overflow-hidden py-4">

            <div className="flex gap-16 whitespace-nowrap animate-[marquee_30s_linear_infinite]">

              {notices.map((n) => (
                <span
                  key={n.id}
                  onClick={() =>
                    (window.location.href = `/notices/${n.id}`)
                  }
                  className="text-white hover:text-[#D4A017] cursor-pointer transition-all duration-300 font-medium text-sm md:text-base"
                >

                  • {n.title}

                </span>
              ))}

            </div>

          </div>

        </div>

      </div>

      {/* SIDEBAR */}
      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO */}
      <Hero />

      {/* MAIN CONTENT */}
      <main className="w-full overflow-x-hidden bg-[#f7f9fc]">

        <div className="max-w-[1600px] mx-auto">

          <WhyChoose />

          <HomeAbout />

          <LifeAtSchool />

          <HomeVirtualTour />

          <News />

        </div>

      </main>

      {/* FOOTER */}
      <Footer />
    </>
  );
};

export default Home;